export const BILLING_TYPE = {
  "REGISTRATION": "REGISTRATION",
  "CUSTOMER": "CUSTOMER",
  "CUSTOMER-RELOCATE": "CUSTOMER RELOCATE",
  "ADDITIONAL-ITEM": "CUSTOM BILLING",
}